import _ from "lodash";
import React from "react";

import { CopyRightTag, PageTitle } from "../../components";
import logo from "../../static/img/riviaos-icon.png";
import KioskDashboard from "./dashboard";

export const LobbyKioskPage = () => {
  return (
    <div className="row portal">
      <PageTitle title="Kiosk" />
      <div className="mx-auto col-md-10 col-12">
        <div className="text-center py-3">
          <img src={logo} alt="CareOS logo" width={150} />
        </div>
        <div className="inner-layer border p-md-5 p-3">
          <KioskDashboard />
        </div>
        <div className="row text-center my-3">
          <CopyRightTag />
        </div>
      </div>
    </div>
  );
};
